import axios from "axios";
import config from "../config";
import { ShareTokenResponse } from "./ResponseModels/ShareTokenResponse";

export async function PostShareModel(imageUuid: string) {
  let response = null;
  response = axios
    .post<ShareTokenResponse>(config.getShareEndpoint, {
      imageUuid: imageUuid,
    })
    .catch((e) => {
      console.error("There was an error!", e);
    });

  return response;
}
